import d from "./index804.js";
import f from "./index805.js";
function m(e, t, i) {
  var n = e == null ? 0 : e.length;
  if (!n)
    return -1;
  var r = n - 1;
  return d(e, f(t), r);
}
export {
  m as default
};
